import {POPULAR_VENUE_LIST, POPULAR_EVENT_LIST, POPULAR_OFFER_LIST} from "../action/actionConstants";

export default function fetchVenueList(state = {venues: "", events: "", offers : ""}, action) {
  switch (action.type) {

    case POPULAR_VENUE_LIST : {
      return {...state,
        venues: action.payload
      }
    }
    case POPULAR_EVENT_LIST : {
      return {...state,
        events : action.payload
      }
    }
    case POPULAR_OFFER_LIST : {
      return {...state,
        offers : action.payload
      }
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/popularSection.js